import { render, staticRenderFns } from "./ToolbarBtns.vue?vue&type=template&id=50aa04ba&scoped=true&"
import script from "./ToolbarBtns.vue?vue&type=script&lang=js&"
export * from "./ToolbarBtns.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarBtns.vue?vue&type=style&index=0&id=50aa04ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aa04ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50aa04ba')) {
      api.createRecord('50aa04ba', component.options)
    } else {
      api.reload('50aa04ba', component.options)
    }
    module.hot.accept("./ToolbarBtns.vue?vue&type=template&id=50aa04ba&scoped=true&", function () {
      api.rerender('50aa04ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/skyQuery/ToolbarBtns.vue"
export default component.exports